import { render } from "./MarketIntelligence.vue?vue&type=template&id=88db78c4&scoped=true"
import script from "./MarketIntelligence.vue?vue&type=script&lang=js"
export * from "./MarketIntelligence.vue?vue&type=script&lang=js"

import "./MarketIntelligence.vue?vue&type=style&index=0&id=88db78c4&lang=css"
import "./MarketIntelligence.vue?vue&type=style&index=1&id=88db78c4&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88db78c4"]])

export default __exports__